<template>
    <div v-show="this.filteredTableData.length">
        <vs-collapse class="suggestion-collapse">
            <vs-collapse-item open>
                <div slot="header">Currently Active CNIC Promos</div>
                <div class="form-actions">
                    <span class="br-line mr-5 ml-5"></span>
                    <vx-tooltip text="Duplicate Promo" position="top">
                        <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-copy" @click="copyPromoData()" :disabled="this.selectedRowCount == 0"></vs-button>
                    </vx-tooltip>
                </div>
                <div>
                    <div id="ag-grid-demo" class="relatedPromo-screen">
                        <div class="related-overly">
                            <div id="grid-loader" class="grid-list vx-card vs-con-loading__container p-0">
                                <ag-grid-vue id="autoHeightGrid" :gridOptions="gridOptions" class="ag-theme-material w-100 mb-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="filteredTableData" components="components" rowSelection="single" :enableRangeSelection="true" :suppressCopyRowsToClipboard="true" colResizeDefault="shift" :suppressDragLeaveHidesColumns="true" :animateRows="true" :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :suppressRowClickSelection="true" :rowClassRules="rowClassRules" :statusBar="statusBar" :sideBar="sideBar" :rowHeight="38" :headerHeight="30" :floatingFiltersHeight="40" :checkboxSelection="true" :domLayout="domLayout" @row-selected="onRowSelected" @column-resized="onColumnResized">
                                </ag-grid-vue>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-collapse-item>
        </vs-collapse>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";

import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererSuggestionsActions from "@/components/ag-grid-tables/actions/CellRendererSuggestionsActions.vue";
import CellRendererStatus from "@/components/ag-grid-tables/actions/CellRendererStatus.vue";

export default {
    name: "CNICPromoSuggestions",
    components: {
        AgGridVue,
        CellRendererSuggestionsActions,
        CellRendererStatus,
    },
    props: {
        client: {
            type: [Object, Array],
        },
        tld: {
            type: [Object, Array],
            // type: Array,
            // default: []
        },
    },
    data() {
        return {
            selectedRowCount: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                resizable: true,
                suppressMenu: true,
                suppressMovable: false,
                filter: false,
            },
            domLayout: null,
            rowClassRules: null,
            statusBar: null,
            sideBar: null,
            rowSelection: null,
            columnDefs: [
                {
                    headerName: "Registrar",
                    field: "new_registrar.unique_registrar.name",
                    filter: "agSetColumnFilter",
                    minWidth: 180,
                    pinned: "left",
                    checkboxSelection: true,
                },
                {
                    headerName: "TLD",
                    field: "tld.tld_name",
                    filter: "agSetColumnFilter",
                    minWidth: 120,
                    pinned: "left",
                    width: 130,
                },
                {
                    headerName: "CNIC ID",
                    field: "new_registrar.cnic_id",
                    filter: "agSetColumnFilter",
                    minWidth: 120,
                    pinned: "left",
                    width: 130,
                },
                {
                    headerName: "Type",
                    field: "type_of_reg",
                    filter: "agSetColumnFilter",
                    minWidth: 130,
                    width: 130,
                },
                {
                    headerName: "Premium",
                    field: "premium",
                    filter: "agSetColumnFilter",
                    minWidth: 130,
                    width: 130,
                },
                {
                    headerName: "Amount",
                    field: "effective_price_amt",
                    filter: "agSetColumnFilter",
                    minWidth: 130,
                    width: 130,
                },
                {
                    headerName: "Percentage",
                    field: "effective_price_per",
                    filter: "agSetColumnFilter",
                    minWidth: 130,
                    width: 130,
                },
                {
                    headerName: "Status",
                    field: "status",
                    filter: "agSetColumnFilter",
                    minWidth: 120,
                    width: 120,
                    cellRenderer: (data) => {
                        return '<div class="badge badge--success inline">Active</div>';
                    },
                },
                {
                    headerName: "Start Date",
                    field: "start_date",
                    filter: "agDateColumnFilter",
                    minWidth: 175,
                    filterParams: {
                        comparator: function (
                            filterLocalDateAtMidnight,
                            cellValue
                        ) {
                            let dateAsString = cellValue;
                            if (dateAsString == null) return -1;
                            let dateParts = dateAsString.split("-");
                            let cellDate = new Date(
                                Number(dateParts[0]),
                                Number(dateParts[1]) - 1,
                                Number(dateParts[2])
                            );
                            if (
                                filterLocalDateAtMidnight.getTime() ===
                                cellDate.getTime()
                            ) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true,
                    },
                },
                {
                    headerName: "End Date",
                    field: "end_date",
                    filter: "agDateColumnFilter",
                    minWidth: 175,
                    filterParams: {
                        comparator: function (
                            filterLocalDateAtMidnight,
                            cellValue
                        ) {
                            let dateAsString = cellValue;
                            if (dateAsString == null) return -1;
                            let dateParts = dateAsString.split("-");
                            let cellDate = new Date(
                                Number(dateParts[0]),
                                Number(dateParts[1]) - 1,
                                Number(dateParts[2])
                            );
                            if (
                                filterLocalDateAtMidnight.getTime() ===
                                cellDate.getTime()
                            ) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true,
                    },
                },
                {
                    headerName: "Promo Name",
                    field: "promo_name",
                    filter: "agSetColumnFilter",
                    minWidth: 300,
                    cellRenderer: (data) => {
                        if (data.value) {
                            return this.capitalizePromoName(data.value);
                        } else {
                            return "";
                        }
                    },
                },
                {
                    headerName: "User",
                    field: "user.name",
                    filter: "agSetColumnFilter",
                    minWidth: 150,
                    width: 150,
                },
                {
                    headerName: "AM",
                    field: "am.name",
                    filter: "agSetColumnFilter",
                    minWidth: 150,
                    width: 150,
                },
            ],
            tableData: [],
            components: {
                CellRendererSuggestionsActions,
                CellRendererStatus,
            },
        };
    },
    watch: {
        windowWidth(val) {
            // Toggle colummn movable
            this.toggleColumnMovable(val);
            // Toggle colummn pinning
            this.toggleColumnPinned(val);
        },

        filteredTableData(val) {
            if (val.length == 0) {
                // var setFlag = false;
                this.$root.$emit("hideRelatedScreen", false);
            } else {
                // var setFlag = true;
                this.$root.$emit("hideRelatedScreen", true);
            }
        },
    },
    computed: {
        windowWidth: function () {
            return this.$store.state.windowWidth;
        },
        paginationPageSize() {
            if (this.gridApi) {
                return this.gridApi.paginationGetPageSize();
            } else {
                return 500;
            }
        },
        totalPages() {
            if (this.gridApi) {
                return this.gridApi.paginationGetTotalPages();
            } else {
                return 0;
            }
        },
        currentPage: {
            get() {
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            },
        },

        formatedClient() {
            if (Array.isArray(this.client)) {
                var ClientName = this.client.map((x) => {
                    return x.value;
                });
            } else {
                var ClientName = [this.client.value];
            }

            return ClientName;
        },

        formatedTld() {
            var tldName = this.tld.map((x) => {
                return x.value;
            });
            return tldName;
        },

        filteredTableData() {
            var filterclientData = this.tableData.filter((x) => {
                return this.formatedClient.includes(x.new_registrar_id);
            });

            var filterTldData = filterclientData.filter((x) =>
                this.formatedTld.includes(x.tld_id)
            );

            if (filterTldData.length) {
                return filterTldData;
            } else {
                return filterclientData;
            }
        },
    },
    methods: {
        openLoadingInDiv() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.8,
            });
        },
        toggleColumnMovable(val) {
            if (val <= 576) {
                this.defaultColDef["suppressMovable"] = true;
            } else {
                this.defaultColDef["suppressMovable"] = false;
            }
        },
        toggleColumnPinned(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("domain", null);
            } else {
                this.gridOptions.columnApi.setColumnPinned("domain", "left");
            }
        },
        onColumnResized() {
            this.gridApi.resetRowHeights();
        },
        sizeColumnsToFit() {
            this.gridApi.sizeColumnsToFit();
        },

        onRowSelected(event) {
            if (event.node.selected) {
                // Push to selectedPromos
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
            } else {
                // Remove from selectedPromos
                this.selectedRowCount = this.gridApi.getSelectedNodes().length;
            }
        },

        setAutoHeight() {
            this.gridApi.setDomLayout("autoHeight");
            // auto height will get the grid to fill the height of the contents,
            // so the grid div should have no height set, the height is dynamic.
            document.querySelector("#autoHeightGrid").style.height = "";
        },

        populateTableData() {
            let self = this;

            /* Get tabel data for std-promo-req */
            this.$axiosSecure
                .get("/cnic-promos")
                .then((response) => {
                    //Passing premium value
                    // alert('api responded');
                    for (var key in response.data) {
                        if (response.data[key].premium == 0) {
                            response.data[key].premium = "No";
                        } else {
                            response.data[key].premium = "Yes";
                        }

                        if (response.data[key].status == "approved") {
                            response.data[key].status = "active";
                        }
                    }
                    // this.tableData = response.data;
                    this.tableData = response.data.filter(
                        (x) =>
                            x["status"] == "active" || x["status"] == "approved"
                    );

                    // console.log('promos', this.tableData);
                })
                .catch((error) => {
                    // Error notification
                    self.$vs.notify({
                        color: "danger",
                        title: "Something went wrong",
                        text: "Please contact the server admin",
                    });

                    console.log(error);
                });
        },
        copyPromoData() {
            // console.log('selected', this.gridApi.getSelectedNodes());
            var selectedRow = this.gridApi
                .getSelectedNodes()
                .map((x) => x.data);
            this.$root.$emit("copyCnicPromo", selectedRow);
        },
        disableQueue() {
            this.rowClassRules = {
                "ag-row-red": 'data && (data.status == "rejected")',
            };
        },
    },
    beforeMount() {
        // Table Data AXIOS Call
        this.populateTableData();
        this.disableQueue();
        // Reset movable columns on mobile
        this.toggleColumnMovable(this.windowWidth);

        // Set Grid sidebar
        this.sideBar = {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressSideButtons: true,
                        suppressColumnSelectAll: true,
                        suppressColumnExpandAll: true,
                    },
                },
            ],
        };
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.addCommentPopup = true;

        //set Auto height
        this.setAutoHeight();

        // Resize to fit columns
        this.sizeColumnsToFit();

        // Reset pinned columns on mobile
        this.toggleColumnPinned(this.windowWidth);

        // Page Refresh Event
        this.$root.$on("refreshPage", () => {
            // Reset filters
            this.gridApi.setFilterModel(null);
            // Reset selection
            this.gridApi.deselectAll();
            // Reset sort
            this.gridApi.setSortModel(null);
            // Table Data AXIOS Call
            this.populateTableData();
        });

        // Page Download Event
        this.$root.$on("downloadPage", () => {
            // AgGrid CSV Export
            this.gridApi.exportDataAsCsv();
        });

        this.$root.$on("duplicatePromoRequest", (rowData) => {
            //console.log('rowData');
            this.$emit("duplicate-suggested-promo", rowData.data);
        });

        let self = this;
    },
    destroyed() {
        // Clear Listing Count
        this.$store.dispatch("clearListingCount");

        // Unbind Button Event Listeners
        this.$root.$off("refreshPage");
        this.$root.$off("duplicatePromoRequest");
        this.$root.$off("downloadPage");
    },
};
</script>

